import { useEffect, useRef, useState } from "react";
import env from "shared/config/env";
import io from "socket.io-client";

const useChessSocket = (inputCode, userName) => {
    const [isJoined, setIsJoined] = useState(false);
    const [players, setPlayers] = useState([]);
    const [gameStarted, setGameStarted] = useState(false);
    const [settings, setSettings] = useState(null);
    const [gs, setGs] = useState(null);
    const [myPlayerNum, setMyPlayerNum] = useState(null);
    const socketRef = useRef(null);

    useEffect(() => {
        return () => socketRef.current?.disconnect();
    }, []);

    const joinRoom = () => {
        if (!inputCode) return;

        socketRef.current = io(env.baseUrl, {
            transports: ["websocket"],
            withCredentials: true,
        });

        socketRef.current.emit("join_room", {
            roomCode: inputCode,
            password: inputCode,
            playerName: userName,
        });

        socketRef.current.on("update_player_list", setPlayers);

        socketRef.current.on("chess_game_started", ({ settings: s, playerOrder }) => {
            setSettings(s);
            setGameStarted(true);
            const myIdx = playerOrder.indexOf(socketRef.current.id);
            setMyPlayerNum(myIdx >= 0 ? myIdx + 1 : 0);
        });

        socketRef.current.on("chess_state_update", ({ edgeMap, tris, cur, over }) => {
            setGs({ edgeMap, tris, cur, over });
        });

        socketRef.current.on("chess_back_to_lobby", () => {
            setGameStarted(false);
            setGs(null);
            setMyPlayerNum(null);
            setSettings(null);
        });

        socketRef.current.on("force_leave_room", () => {
            exitRoom();
            alert("ห้องถูกรีเซ็ตแล้ว");
        });

        setIsJoined(true);
    };

    const startGame = (pendingSettings) => {
        socketRef.current?.emit("chess_start_game", {
            roomCode: inputCode,
            settings: pendingSettings,
        });
    };

    const placeEdge = (edgeMap, tris, cur, over) => {
        socketRef.current?.emit("chess_place_edge", {
            roomCode: inputCode,
            edgeMap,
            tris,
            cur,
            over,
        });
    };

    const resetGame = () => {
        socketRef.current?.emit("chess_reset_game", { roomCode: inputCode });
    };

    const backToLobby = () => {
        socketRef.current?.emit("chess_back_to_lobby", { roomCode: inputCode });
    };

    const exitRoom = () => {
        socketRef.current?.disconnect();
        setIsJoined(false);
        setPlayers([]);
        setGameStarted(false);
        setSettings(null);
        setGs(null);
        setMyPlayerNum(null);
    };

    return {
        isJoined,
        players,
        gameStarted,
        settings,
        gs,
        myPlayerNum,
        socketRef,
        joinRoom,
        startGame,
        placeEdge,
        resetGame,
        backToLobby,
        exitRoom,
    };
};

export default useChessSocket;
